const firstCharToLowerCase = (value)=>value[0].toLowerCase() + value.slice(1);
const isEmpty = (value)=>null == value || '' === value;
const pascalCase = (text)=>text.split('-').map((t)=>t[0].toUpperCase() + t.slice(1)).join('');
const isAllCaps = /^[\dA-Z]+$/;
const kebabCase = (text)=>isAllCaps.test(text) ? text : text.replace(/([A-Z])/, (match)=>`-${match[0].toLowerCase()}`);
export { firstCharToLowerCase, isEmpty, kebabCase, pascalCase };
